"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectDestructuringEmpty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _FormikFormPhoneNumber = _interopRequireDefault(require("./FormikFormPhoneNumber"));
var _FormikFieldComponent = require("./FormikFieldComponent");
var Formik = {
  createFormikFieldComponent: _FormikFieldComponent.createFormikFieldComponent,
  FormikFieldComponent: _FormikFieldComponent.FormikFieldComponent,
  PhoneNumber: _FormikFormPhoneNumber["default"]
};
Formik.Input = function (_ref) {
  var props = (0, _extends2["default"])({}, ((0, _objectDestructuringEmpty2["default"])(_ref), _ref));
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, (0, _extends2["default"])({
    component: _FormikFieldComponent.FormikFieldComponent
  }, props));
};
var _default = exports["default"] = Formik;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/Formik.js
// module id = 2135
// module chunks = 25